module.exports = __webpack_public_path__ + "img/kf.27f7dc9e.png";